import { render } from "./ItemEntranceList.vue?vue&type=template&id=25e24a98"
import script from "./ItemEntranceList.vue?vue&type=script&lang=js"
export * from "./ItemEntranceList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/h5/luqiao/entrance/ItemEntranceList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "25e24a98"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('25e24a98', __exports__)) {
    api.reload('25e24a98', __exports__)
  }
  
  module.hot.accept("./ItemEntranceList.vue?vue&type=template&id=25e24a98", () => {
    api.rerender('25e24a98', render)
  })

}


export default __exports__